// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DeleteTwoToneSvg from "@ant-design/icons-svg/es/asn/DeleteTwoTone";
import AntdIcon from '../components/AntdIcon';

var DeleteTwoTone = function DeleteTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DeleteTwoToneSvg
  }));
};

DeleteTwoTone.displayName = 'DeleteTwoTone';
export default React.forwardRef(DeleteTwoTone);